// extracted by mini-css-extract-plugin
export default {"container":"authLayout_container__eGKDG","wrapper":"authLayout_wrapper__9g4HF"};